import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EncuestaClienteService } from '../../services/encuesta-cliente/encuesta-cliente.service';
import { EncuestaCliente } from '../../models/encuesta-cliente.model';
import { Respuesta } from '../../models/respuesta.model';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-encuesta-page',
  templateUrl: './encuesta-page.component.html',
  styleUrl: './encuesta-page.component.scss'
})
export class EncuestaPageComponent {

  private idEncuestaCliente: string = '';
  public encuestaCliente?: EncuestaCliente;

  constructor(
    private activatedRoute: ActivatedRoute,
    private encuestaClienteService: EncuestaClienteService,
    private router: Router,
    private titleService: Title
  ) {

    this.activatedRoute.params.subscribe(
      async params => {

        this.idEncuestaCliente = params['idEncuestaCliente'];

        this.getData();
      }
    );

  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR getData                               */
  /* -------------------------------------------------------------------------- */
  // region getData
  async getData() {

    this.encuestaCliente = await this.encuestaClienteService.get(
      this.idEncuestaCliente
    );

    if(this.encuestaCliente) {

      this.titleService.setTitle(
        `${this.encuestaCliente.encuesta?.nombre} | ${this.encuestaCliente.empresa?.razonSocial}`
      )

      if(this.encuestaCliente.contestado) {
        this.router.navigate(['/complete']);
      }
    }

  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR isDisabled                             */
  /* -------------------------------------------------------------------------- */
  // region isDisabled
  isDisabled() {

    let flag = false;

    this.encuestaCliente?.paso?.preguntas.forEach(
      (pregunta) => {

        // console.log(pregunta);
        
        if(
          !pregunta?.rango &&
          !pregunta?.respuesta &&
          pregunta?.respuestas.length === 0
        ) {
          flag = true;
          
        } else {
          
          if(pregunta.rangos.length > 0) {

            for(const rango of pregunta.rangos) {

              if(
                pregunta.rango !== undefined &&
                pregunta.rango >= rango.valorMinimo &&
                pregunta.rango <= rango.valorMaximo
              ) {

                // console.log('Esta dentro del rango');
                

                for(const preguntaRango of rango.preguntas) {

                  if(
                    !preguntaRango?.rango &&
                    !preguntaRango?.respuesta &&
                    preguntaRango?.respuestas.length === 0
                  ) {

                    // console.log('Pregunta rango sin respuesta:', preguntaRango);

                    flag = true;
                  } else {

                    // console.log('Pregunta rango con respuesta:', preguntaRango);

                    // flag = false;
                  }

                }

                // console.log(
                //   'flag despues del for rango',
                //   flag
                // );
                

              } else {

                // console.log('Esta fuera del rango');                

                // flag = false;
              }

            }

          } else if(pregunta.respuesta) {

            for(const preguntaHija of pregunta.respuesta.preguntas!) {
              if(
                !preguntaHija?.rango &&
                !preguntaHija?.respuesta &&
                preguntaHija?.respuestas.length === 0
              ) {
                flag = true;
              }
            }

          } else if(pregunta.respuestas.length > 0) {

            for(const respuesta of pregunta.respuestas) {

              for(const preguntaHija of respuesta.preguntas!) {
                if(
                  !preguntaHija?.rango &&
                  !preguntaHija?.respuesta &&
                  preguntaHija?.respuestas.length === 0
                ) {
                  flag = true;
                }
              }

            }

          }

        }
      }
    );

    // console.log('flag', flag);

    return flag;
  }

  /* -------------------------------------------------------------------------- */
  /*                               ANCHOR onSubmit                              */
  /* -------------------------------------------------------------------------- */
  // region onSubmit
  async onSubmit() {
    console.log(this.encuestaCliente?.paso?.preguntas);

    let respuestas: Respuesta[] = [];

    this.encuestaCliente?.paso?.preguntas.forEach(
      (pregunta) => {

        if(pregunta.respuestas.length > 0) {

          pregunta.respuestas.forEach(
            (answer) => {

              const respuesta = new Respuesta({
                idPregunta: pregunta.idPregunta,
                idRespuesta: answer.idRespuesta,
                valorRango: 0,
                valorRespuesta: answer.respuesta,
                otroTexto: answer.permiteTexto
                  ? answer.respuestaTexto
                  : ''
              });

              respuestas.push(respuesta);

              answer.preguntas.forEach(
                (preguntaHija) => {

                  console.log(preguntaHija);
                  

                  if(preguntaHija.respuestas.length > 0) {

                    preguntaHija.respuestas.forEach(
                      (answerHija) => {

                        const respuesta = new Respuesta({
                          idPregunta: preguntaHija.idPregunta,
                          idRespuesta: answerHija.idRespuesta,
                          valorRango: 0,
                          valorRespuesta: answerHija.respuesta,
                          otroTexto: answerHija.permiteTexto
                            ? answerHija.respuestaTexto
                            : ''
                        });

                        respuestas.push(respuesta);

                      }
                    );

                  } else {

                    const respuesta = new Respuesta({
                      idPregunta: preguntaHija.idPregunta,
                      idRespuesta: preguntaHija.respuesta?.idRespuesta,
                      valorRango: preguntaHija.rango 
                        ? preguntaHija.rango 
                        : 0,
                      valorRespuesta: preguntaHija.respuesta 
                        ? preguntaHija.respuesta.respuesta 
                        : '',
                      otroTexto: preguntaHija.respuesta && preguntaHija.respuesta.permiteTexto
                        ? preguntaHija.respuesta.respuestaTexto
                        : ''
                    });

                    respuestas.push(respuesta);
                  }
                }
              );

            }
          );

        } else {

          const respuesta = new Respuesta({
            idPregunta: pregunta.idPregunta,
            idRespuesta: pregunta.respuesta?.idRespuesta,
            valorRango: pregunta.rango 
              ? pregunta.rango 
              : 0,
            valorRespuesta: pregunta.respuesta 
              ? pregunta.respuesta.respuesta 
              : '',
            otroTexto: pregunta.respuesta && pregunta.respuesta.permiteTexto
              ? pregunta.respuesta.respuestaTexto
              : ''
          });

          respuestas.push(respuesta);
          
          if(pregunta.respuesta) {

            pregunta.respuesta.preguntas.forEach(
              (preguntaHija) => {

                if(preguntaHija.respuestas.length > 0) {

                  preguntaHija.respuestas.forEach(
                    (answerHija) => {

                      const respuesta = new Respuesta({
                        idPregunta: preguntaHija.idPregunta,
                        idRespuesta: answerHija.idRespuesta,
                        valorRango: 0,
                        valorRespuesta: answerHija.respuesta,
                        otroTexto: answerHija.permiteTexto
                          ? answerHija.respuestaTexto
                          : ''
                      });

                      respuestas.push(respuesta);

                    }
                  );

                } else {

                  const respuesta = new Respuesta({
                    idPregunta: preguntaHija.idPregunta,
                    idRespuesta: preguntaHija.respuesta?.idRespuesta,
                    valorRango: preguntaHija.rango 
                      ? preguntaHija.rango 
                      : 0,
                    valorRespuesta: preguntaHija.respuesta 
                      ? preguntaHija.respuesta.respuesta 
                      : '',
                    otroTexto: preguntaHija.respuesta && preguntaHija.respuesta.permiteTexto
                      ? preguntaHija.respuesta.respuestaTexto
                      : ''
                  });

                  respuestas.push(respuesta);
                }

              }
            );

          }

          pregunta.rangos.forEach(
            (rango) => {

              if(
                pregunta.rango !== undefined &&
                pregunta.rango >= rango.valorMinimo &&
                pregunta.rango <= rango.valorMaximo
              ) {

                rango.preguntas.forEach(
                  (preguntaRango) => {

                    if(preguntaRango.respuestas.length > 0) {

                      preguntaRango.respuestas.forEach(
                        (answer) => {

                          const respuesta = new Respuesta({
                            idPregunta: preguntaRango.idPregunta,
                            idRespuesta: answer.idRespuesta,
                            valorRango: 0,
                            valorRespuesta: answer.respuesta,
                            otroTexto: answer.permiteTexto
                              ? answer.respuestaTexto
                              : ''
                          });

                          respuestas.push(respuesta);

                        }
                      );

                    } else {

                      const respuesta = new Respuesta({
                        idPregunta: preguntaRango.idPregunta,
                        idRespuesta: preguntaRango.respuesta?.idRespuesta,
                        valorRango: preguntaRango.rango 
                          ? preguntaRango.rango 
                          : 0,
                        valorRespuesta: preguntaRango.respuesta 
                          ? preguntaRango.respuesta.respuesta 
                          : '',
                        otroTexto: preguntaRango.respuesta && preguntaRango.respuesta.permiteTexto
                          ? preguntaRango.respuesta.respuestaTexto
                          : ''
                      });

                      respuestas.push(respuesta);
                    }
                  }
                  
                );

              }

            }
          );

        }


      }
    );

    console.log(respuestas);

    // return;

    const flag = await this.encuestaClienteService.create(
      this.idEncuestaCliente,
      respuestas
    );

    if(flag) {
      this.getData();
    }
      
  }

}
